export default "__VITE_ASSET__BZU9h75T__"